import React from 'react'
import PropTypes from 'prop-types'
import Sidebar from '../Sidebar/Sidebar'
import Topbar from '../Topbar/Topbar'
import Authenticate from '../Auth/Authenticate'
import styles from './defaultLayout.module.scss'

const DefaultLayout = (props) => {
  const { children, hiddenSearch } = props

  return (
    <Authenticate>
      <div className={styles.defaultLayout} id="layout">
        <Sidebar />
        <main>
          <Topbar hiddenSearch={hiddenSearch} />
          {children}
        </main>
      </div>
    </Authenticate>
  )
}

DefaultLayout.defaultProps = {
  children: null,
  hiddenSearch: false
}

DefaultLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.element)
  ]),
  hiddenSearch: PropTypes.bool
}

export default DefaultLayout
